import { render, staticRenderFns } from "./editCardManagement.vue?vue&type=template&id=4bfc2090&scoped=true&"
import script from "./editCardManagement.vue?vue&type=script&lang=js&"
export * from "./editCardManagement.vue?vue&type=script&lang=js&"
import style0 from "./editCardManagement.vue?vue&type=style&index=0&id=4bfc2090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfc2090",
  null
  
)

export default component.exports